<template>
  <div class="inventory">
    <div class="inventory-container">
      <div class="top-container">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="demo-ruleForm"
          label-width="80px"
        >
          <div class="row">
            <!-- v-if="!isCanteenAdmin" -->
            <el-form-item label="食堂：" prop="canteen">
              <el-select
                v-model="ruleForm.canteen"
                placeholder="请选择"
                class="w200"
                clearable
              >
                <el-option
                  v-for="item in canteenList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="物料名称：" prop="materialName">
              <el-input
                class="gray white w200"
                placeholder="请输入"
                v-model="ruleForm.materialName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item class="btn">
              <el-button class="btn-gray" @click="resetForm('ruleForm')"
                >重置</el-button
              >
              <el-button class="btn-blue" type="primary" @click="search"
                >搜索</el-button
              >
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="container">
        <div class="table" v-if="tableData.length > 0">
          <el-table :data="tableData">
            <el-table-column
              v-for="(item, index) in tableTitleList"
              :key="index"
              :prop="item.prop"
              :label="item.lable"
              :width="item.width"
              show-overflow-tooltip
            />
            <!-- v-if="!isCanteenAdmin" -->
            <el-table-column
              v-if="
                OPERATION_LIST.findIndex(
                  (item) => item === OPERATIONS_BTNS.roleApplyMaterial
                ) !== -1
              "
              label="操作"
              width="120"
            >
              <template slot-scope="scope">
                <el-button type="text" class="btn-text" @click="claim(scope.row)"
                  >领用</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-tpl-container">
            <pagination-tpl
              :total="totalNum"
              :currentPage="currentPage"
              @queryChange="onQueryChange"
            ></pagination-tpl>
          </div>
        </div>
        <div class="nothing" v-if="tableData.length == 0">
          <div>
            <div>
              <img src="../../../../assets/nothing.png" />
            </div>
            <p>暂无数据</p>
          </div>
        </div>
      </div>
    </div>


    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <div class="claim-container">
        <div class="claim-top">
          <div class="materialCategoryName">
            <div class="claim-title">分类名称</div>
            <el-input
              class="gray white"
              disabled
              v-model="materialCategoryName"
            ></el-input>
          </div>
          <div>
            <div class="claim-title">物料名称</div>
            <el-input
              class="gray white"
              disabled
              v-model="materialName"
            ></el-input>
          </div>
        </div>
        <div class="claim-content">
          <div class="claim-title">数量</div>
          <div
            class="claim-main"
            :class="detailList.length > 1 ? 'add-right' : ''"
          >
            <el-input
              v-for="(item, index) in detailList"
              :key="index"
              class="gray white"
              :class="index % 2 ? 'no-right' : ''"
              v-model="item.num"
            >
              <span slot="suffix">{{ UNIT[item.unitType] }}</span>
            </el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confrim">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { config } from "@/common/js/config.js";
import PaginationTpl from "@/components/PaginationTpl.vue";
import Inventory from "@/models/inventory.js";
import Canteen from "@/models/canteen.js";
import { formatTimeToDate, handleAmount } from "@/common/js/utils.js";
import { operationMixins } from "@/common/mixins/operation/operation.js";
import { statusMixins } from "@/common/mixins/status/status.js";
export default {
  mixins: [operationMixins, statusMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      /* 是否是食堂管理员; 1.是， 0，不是 */
      isCanteenAdmin: 1,
      tableData: [],
      tableTitleList: [
        { prop: "canteenName", lable: "食堂名称", width: "" },
        { prop: "materialCategoryName", lable: "分类", width: "" },
        { prop: "materialName", lable: "物料名称", width: "" },
        { prop: "num", lable: "数量", width: "" },
        { prop: "lastPurchaseTime", lable: "上次采购时间", width: "" },
      ],
      totalNum: 0,
      currentPage: 1,
      ruleForm: {
        canteen: "",
        materialName: "",
      },
      canteenList: [],
      dialogTitle: "领用",
      dialogVisible: false,
      /* 物料分类名称 */
      materialCategoryName: "",
      /* 物料名称 */
      materialName: "",
      /* 物料数量集合 */
      detailList: [],
    };
  },

  created() {
    config();
    this.initCanteenList();
    this.initTableList();
  },

  methods: {
    initTableList() {
      let canteenId = this.ruleForm.canteen;
      let name = this.ruleForm.materialName;
      let currentPage = this.currentPage;
      Inventory.getInventoryList(canteenId, name, currentPage).then((res) => {
        if (res.success) {
          let arr = [];
          this.totalNum = res.result.totalNum;
          res.result.items.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.canteenName = i.canteenName;
            obj.materialCategoryName = i.materialCategoryName;
            obj.materialName = i.materialName;
            obj.detailList = [];
            let num = "";
            let lastPurchaseTimeList = [];
            i.detailList.map((v) => {
              let obj2 = {};
              num = `${num}/${handleAmount(v.num, 2)}${
                this.UNIT[v.unitType]
              }`;
              lastPurchaseTimeList.push(v.lastPurchaseTime);

              obj2.num = handleAmount(v.num, 2);
              obj2.lastPurchaseTime = v.lastPurchaseTime;
              obj2.id = v.id;
              obj2.unitType = v.unitType;
              obj.detailList.push(obj2);
            });
            obj.num = num.substring(1);
            let maxLastPurchaseTime = Math.max(...lastPurchaseTimeList);
            obj.lastPurchaseTime = maxLastPurchaseTime
              ? formatTimeToDate(maxLastPurchaseTime)
              : "";
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 获取食堂数据 */
    initCanteenList() {
      Canteen.getCanteenNoPageList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            arr.push(obj);
          });
          this.canteenList = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initTableList();
    },

    /* 搜索 */
    search() {
      this.currentPage = 1;
      this.initTableList();
    },

    /* 重置 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    /* 领用 */
    claim(row) {
      this.materialCategoryName = row.materialCategoryName;
      this.materialName = row.materialName;
      this.detailList = row.detailList;
      this.dialogVisible = true;
    },

    handleClose() {
      this.dialogVisible = false;
    },

    confrim() {
      let receiveInfoList = [];
      this.detailList.map((i) => {
        let obj = {};
        obj.quantity = handleAmount(i.num, 1);
        obj.unitType = i.unitType;
        obj.storageId = i.id;
        receiveInfoList.push(obj);
      });
      let data = {
        receiveInfoList,
      };
      Inventory.postClaim(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "领用成功",
          });
          this.handleClose();
          this.initTableList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
  },
};
</script>

<style lang='scss'>
.inventory {
  .claim-container {
    padding: 16px 32px;
    .claim-top {
      @include flex-start;
      margin-bottom: 20px;
      .materialCategoryName {
        margin-right: 20px;
      }
      > div {
        width: 50%;
      }
    }
    .claim-title {
      height: 30px;
      line-height: 30px;
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-grey;
      text-align: left;
    }
    .claim-content {
      .claim-main {
        @include flex-start;
        .el-input {
          .el-input__suffix {
            top: 9px;
          }
        }
        .no-right {
          margin-right: 0px !important;
        }
      }
      .add-right {
        .el-input {
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
